import type {
  RatingDisplaySlots as RatingDisplayBaseSlots,
  RatingDisplayBaseProps,
  RatingDisplayBaseState,
  RatingDisplayContextValues as RatingDisplayContextValuesBase,
} from '@fluentui/react-rating';

/**
 * RatingDisplay component slots
 */
export type RatingDisplaySlots = RatingDisplayBaseSlots;

/**
 * RatingDisplay component props
 */
export type RatingDisplayProps = RatingDisplayBaseProps;

/**
 * RatingDisplay component state
 */
export type RatingDisplayState = RatingDisplayBaseState;

/**
 * RatingDisplay component context values
 */
export type RatingDisplayContextValues = RatingDisplayContextValuesBase;
